<template>
  <div>
     <div class="top">
      <div class="top_title">
        <div class="top_left">
          <img src="~assets/images/serve.png" alt />
          <span class="name">{{topMessageData.fromName}}</span>
        </div>
        <div class="top_right">置顶</div>
      </div>
      <div class="adv" v-html="topMessageData.message">
      </div>
    </div> 
  </div>
</template>

<script>
export default {
  props:['topMessageData']
};
</script>

<style lang="scss" >
@import "~assets/styles/mixin";
.top {
  border-radius: 0.06rem;
  text-align: center;
  background: #fff;
  margin: 0.2rem 0.1rem;
  font-size: 0;
  position: absolute;
  top: 0;
  // z-index: 100;
   .top_title {
    @include fj();
    .top_left {
      img {
        @include wh(0.64rem, 0.64rem);
        vertical-align: middle;
      }
      .name {
        @include sc(0.24rem, #0a95ff);
        vertical-align: middle;
      }
    }

    .top_right {
      @include wh(0.8rem, 0.34rem);
      @include bis("~assets/images/icon-sprite.png", 3.34rem, 3.2rem);
      @include bp(-0.1rem, -0.1rem);
      @include sc(0.22rem, #fb605a);
      text-align: center;
    }
  }
}

.adv {
  img {
    @include wh(6.9rem, 1.18rem);
    margin-top: 0.2rem;
  }
}
</style>